import * as React from "react";
import { List, Datagrid, TextField, ReferenceInput, SelectInput, Button, useDataProvider, useNotify, useRefresh, useListContext } from 'react-admin';
import { FbDateRangeField, formatRange } from "../components/FbDateField";

const GenerateTimesheetButton = ({ record }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [loading, setLoading] = React.useState(false);

    const handleClick = () => {
        setLoading(true);
        dataProvider.create('timesheets', {
            data: {
                employment_id: record.id,
                timesheet_week_id: record.timesheet_week_id,
            }
        }).then(() => {
            notify('Timesheet generated successfully', 'success');
            refresh();
        }).catch(error => {
            notify(error.message || 'Failed to generate timesheet', 'error');
        }).finally(() => setLoading(false));
    };

    return <Button label="Generate" onClick={handleClick} disabled={loading} />;
};

const MissingTimesheetsGrid = () => {
    const { filterValues } = useListContext();
    if (!filterValues.timesheet_week_id) {
        return <p style={{ padding: '16px' }}>Select a week to view missing timesheets.</p>;
    }
    return (
        <Datagrid>
            <TextField source="employment_name" label="Employment" sortable={false} />
            <TextField source="employment_job_title" label="Job Title" sortable={false} />
            <TextField source="department_name" label="Department" sortable={false} />
            <FbDateRangeField label="Week" startDateSource="week_start_date" endDateSource="week_end_date" extraSource="week_reference" sortable={false} />
            <GenerateTimesheetButton label="Action" />
        </Datagrid>
    );
};

const filters = [
    <ReferenceInput label="Week" source="timesheet_week_id" reference="timesheet-weeks" perPage={100} alwaysOn>
        <SelectInput optionText={record => formatRange(record.start_date, record.end_date, record.production_reference)} />
    </ReferenceInput>,
];

export const MissingTimesheetsList = props => (
    <List
        {...props}
        filters={filters}
        bulkActionButtons={false}
        title="Missing Timesheets"
        sort={{ field: 'department_name', order: 'ASC' }}
        empty={false}
    >
        <MissingTimesheetsGrid />
    </List>
);
